import React from "react";
import { FiShoppingBag } from "react-icons/fi";
import "./Hero.scss";

const Hero = () => {
  return (
    <div className="hero">
      <h1 className="hero-title">
        Обирай найкращі меблі в Україні разом з MebliM
      </h1>

      <div className="icon-wrapper icon1">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/800px-Google_%22G%22_logo.svg.png" alt="Icon 1" />
      </div>
      <div className="icon-wrapper icon2">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/800px-Google_%22G%22_logo.svg.png" alt="Icon 2" />
      </div>
      <div className="icon-wrapper icon3">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/800px-Google_%22G%22_logo.svg.png" alt="Icon 3" />
      </div>
      <div className="icon-wrapper icon4">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/800px-Google_%22G%22_logo.svg.png" alt="Icon 4" />
      </div>
      <div className="icon-wrapper icon5">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/800px-Google_%22G%22_logo.svg.png"
          alt="Icon 5"
        />
      </div>
      <div className="icon-wrapper icon6">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/800px-Google_%22G%22_logo.svg.png"
          alt="Icon 6"
        />
      </div>

      <div className="gradient-background">
        <div className="big-circle">
          <div className="inner-circle1"></div>
          <div className="inner-circle2"></div>
          <div className="inner-circle3"></div>

          <div className="icon-container pos-top-middle">
            <span className="icon-item">
              <FiShoppingBag />
            </span>
          </div>

          <div className="icon-container pos-top-left">
            <span className="icon-item">
              <FiShoppingBag />
            </span>
          </div>

          <div className="icon-container pos-top-right">
            <span className="icon-item">
              <FiShoppingBag />
            </span>
          </div>

          <div className="icon-container pos-bottom-left">
            <span className="icon-item">
              <FiShoppingBag />
            </span>
          </div>

          <div className="icon-container pos-bottom-right">
            <span className="icon-item">
              <FiShoppingBag />
            </span>
          </div>

          <div className="icon-container pos-bottom-middle">
            <span className="icon-item">
              <FiShoppingBag />
            </span>
          </div>

          <div className="icon-container pos-mid-left">
            <span className="icon-item">
              <FiShoppingBag />
            </span>
          </div>

          <div className="icon-container pos-mid-right">
            <span className="icon-item">
              <FiShoppingBag />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
